import React from 'react';

const FormTextarea = ({ 
  label, 
  name, 
  value, 
  onChange, 
  error, 
  required = false, 
  placeholder = '',
  icon = '',
  rows = 4,
  className = '',
  ...props 
}) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-xs font-bold text-gray-700 mb-1.5">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        className={`w-full px-3 py-2 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm leading-relaxed ${
          error 
            ? 'border-red-400 bg-red-50' 
            : 'border-gray-300 hover:border-blue-300 bg-white'
        }`}
        placeholder={placeholder}
        {...props}
      />
      {error && (
        <p className="mt-1 text-xs text-red-600 font-medium flex items-center gap-1">
          <span>⚠️</span>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormTextarea;
